// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"660c86fa","732":"65aec10b","946":"77642148"}[chunkId] + ".chunk.js";
};